import type { TableColumn } from "react-data-table-component";
import styles from "./TableSkelton.module.scss";
import { combineClasses } from "@/lib/utils";
import NoDataIcon from "@/components/SVGComponents/NoData";

interface NoDataProps<T> {
  columns: TableColumn<T>[];
  sidebarOpen?: boolean;
  message?: string;
}

const NoData = <T,>({ columns, sidebarOpen, message = "There are no records to display" }: NoDataProps<T>) => {
  return (
    <div
      style={{
        width: sidebarOpen ? "calc(100vw - 327px)" : "calc(100vw - 165px)",
      }}
      className={combineClasses(styles.table, styles.noBorder)}
    >
      <div>
        <div className={combineClasses(styles.row, styles.heading)}>
          {columns?.map((column) => (
            <div key={column.name as string} style={{ width: column.width || "100px" }}>
              {column?.name as string}
            </div>
          ))}
        </div>
        <div
          className={styles.row}
          style={{ justifyContent: "center", padding: "2rem", height: "calc(100vh - 220px)" }}
        >
          <div style={{ width: "100%", textAlign: "center" }}>
            <NoDataIcon style={{ width: "150px", marginBottom: "1rem" }} />
            <p style={{ margin: 0, color: "#666", fontSize: "16px" }}>{message}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NoData;
